import Stack from '@eversports/klimt-primitives/legacy/Stack'

import {
  EventRegistrationWindowState,
  type OpenTimeRange,
  type RegistrationState,
  type SpotLimit,
} from '../../ActivityDetails.types'

import BookNowButton from './BookNowButton'
import NotBookableAlert from './NotBookableAlert'
import UrgencyAlert from './UrgencyAlert'

interface Props {
  bookableItemId: string
  venueId: string
  availableSpots: SpotLimit | null
  registrationState: RegistrationState
  registrationWindowState: EventRegistrationWindowState
  registrationWindow: OpenTimeRange
}

const CallToAction = ({
  availableSpots,
  bookableItemId,
  venueId,
  registrationState,
  registrationWindowState,
  registrationWindow,
}: Props) => {
  return (
    <Stack gap={2} alignItems="center" sx={{ width: '100%' }}>
      <BookNowButton bookableItemId={bookableItemId} venueId={venueId} registrationState={registrationState} />
      <UrgencyAlert availableSpots={availableSpots} isBookable={registrationState.bookable} />
      <NotBookableAlert
        registrationState={registrationState}
        registrationWindowState={registrationWindowState}
        registrationWindow={registrationWindow}
      />
    </Stack>
  )
}
export default CallToAction
